import React from "react";
import PropTypes from "prop-types";
import colors from "app/theme/base/colors";
import { alpha } from "@mui/material/styles";

function GhostExerciseSlotItem({ exercise, fontSize, maxLines }) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        padding: "4px 6px",
        borderRadius: "8px",

        backgroundColor: colors.background.paper,
        border: `1px solid ${colors.primary.main}`,

        boxShadow: `0 6px 14px ${alpha(colors.black.main, 0.25)}`,
        opacity: 0.95,
        transform: "scale(1.02)",
        transition: "all 0.15s ease",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        userSelect: "none",
      }}
    >
      <div
        style={{
          width: "100%",
          textAlign: "center",

          display: "-webkit-box",
          WebkitLineClamp: maxLines,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",

          fontSize,
          lineHeight: "1.25rem",
          color: colors.text.primary,
          fontWeight: 450,
        }}
      >
        {exercise?.name}
      </div>
    </div>
  );
}

GhostExerciseSlotItem.propTypes = {
  exercise: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  fontSize: PropTypes.string.isRequired,
  maxLines: PropTypes.number.isRequired,
};

export default GhostExerciseSlotItem;
